// src/views/about.ts

type AboutOpts = {
  onBack: () => void;
};

export function renderAbout(root: HTMLElement, opts: AboutOpts): void {
  root.innerHTML = `
    <header class="app-header">
      <span class="brand">Barve</span>
      <span>About</span>
    </header>
    <div class="card">
      <p class="about-text">
        <em>Barve</em> is the Slovenian word for "colors"
        <span class="about-pronunciation">(BAR-veh)</span>.
        This is a daily color perception game — five rounds, one share.
      </p>
      <p class="about-text">
        Have fun, share your scores, and if you have feedback
        we'd love to hear it.
      </p>
      <p class="about-text">
        For another fun game, check out
        <a class="about-link" href="https://www.gertjack.com" target="_blank" rel="noopener">gertjack.com</a>.
      </p>
      <button class="results-stats-link" id="about-back" type="button">Back</button>
    </div>
  `;
  root.querySelector('#about-back')!.addEventListener('click', opts.onBack);
}
